module.exports = __webpack_public_path__ + "img/social-info1.c1945140.png";